<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M1,2C1,2,15,2,15,2C15.55,2,16,1.55,16,1C16,0.45,15.55,0,15,0C15,0,1,0,1,0C0.45,0,0,0.45,0,1C0,1.55,0.45,2,1,2C1,2,1,2,1,2ZM15,13C15,13,1,13,1,13C0.45,13,0,13.45,0,14C0,14.55,0.45,15,1,15C1,15,15,15,15,15C15.55,15,16,14.55,16,14C16,13.45,15.55,13,15,13C15,13,15,13,15,13ZM3,5C2.45,5,2,5.45,2,6C2,6,2,9,2,9C2,9.55,2.45,10,3,10C3,10,12,10,12,10C12.55,10,13,9.55,13,9C13,9,13,6,13,6C13,5.45,12.55,5,12,5C12,5,3,5,3,5C3,5,3,5,3,5Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'VerticalDistribution',
} as DefineComponent
</script>
